module.exports = {"title":"그레이드와 함께<br />새로운 여정을 시작해보세요!","reviewer":{"title":"리뷰어 신청","content":"함께할 그레이더(리뷰어)를 모집합니다.","hashtag":"#리뷰어 #그레이더 #내돈내산 #리뷰하고돈벌자"},"seller":{"title":"셀러 신청","content":"그레이드에 입점할 셀러를 모집합니다.","hashtag":"#셀러 #셀러입점 #너무쉬운 #5분입점"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/register.json
// module id = B5fl
// module chunks = 1